import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CommunityViewerComponent } from "./community-viewer.component";
import { LatestDiscussionsComponent } from "./latest-discussions/latest-discussions.component";
import { TrendingDiscussionsComponent } from "./trending-discussions/trending-discussions.component";
import { ViewableCommunityResolver } from "../../../shared/services";

const routes: Routes = [
  {
    path: "", // path is "community/:communityName"
    component: CommunityViewerComponent,
    data: {
      title: "Community page",
      icon: "ti-user",
      caption: "View community page and discussions here",
      status: true,
    },
    resolve: {
      community: ViewableCommunityResolver,
    },
    children: [
      {
        path: "",
        component: LatestDiscussionsComponent,
      },
      {
        path: "trending",
        component: TrendingDiscussionsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CommunityViewerRoutingModule {}
